import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes de inventario
import DashboardInventario from "./components/DashboardInventario";
import ProductosInventario from "./components/ProductosInventario";
import Movimientos from "./components/Movimientos";
import Almacenes from "./components/Almacenes";
import AjustesInventario from "./components/AjustesInventario";
import Transferencias from "./components/Transferencias";
import ReportesInventario from "./components/ReportesInventario";
import Categorias from "./components/Categorias";

import { useMaterialUIController } from "context";

export default function Inventario() {
  const [controller] = useMaterialUIController();
  const { sidenavColor, selectedCompanyId } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <DashboardInventario companyId={selectedCompanyId} />;
      case 1:
        return <ProductosInventario companyId={selectedCompanyId} />;
      case 2:
        return <Movimientos companyId={selectedCompanyId} />;
      case 3:
        return <Almacenes companyId={selectedCompanyId} />;
      case 4:
        return <AjustesInventario companyId={selectedCompanyId} />;
      case 5:
        return <Transferencias companyId={selectedCompanyId} />;
      case 6:
        return <Categorias companyId={selectedCompanyId} />;
      case 7:
        return <ReportesInventario companyId={selectedCompanyId} />;
      default:
        return <DashboardInventario companyId={selectedCompanyId} />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Módulo de Gestión de Inventario
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  sx={{ px: 3 }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Dashboard" icon={<Icon>dashboard</Icon>} iconPosition="start" />
                  <Tab label="Productos" icon={<Icon>inventory_2</Icon>} iconPosition="start" />
                  <Tab label="Movimientos" icon={<Icon>swap_horiz</Icon>} iconPosition="start" />
                  <Tab label="Almacenes" icon={<Icon>warehouse</Icon>} iconPosition="start" />
                  <Tab label="Ajustes" icon={<Icon>tune</Icon>} iconPosition="start" />
                  <Tab
                    label="Transferencias"
                    icon={<Icon>local_shipping</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Categorías" icon={<Icon>category</Icon>} iconPosition="start" />
                  <Tab label="Reportes" icon={<Icon>assessment</Icon>} iconPosition="start" />
                </Tabs>
              </MDBox>
              <MDBox p={3}>{renderContent()}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
